import { Component } from '@angular/core';

import { TableCellState } from '../../table.state';
import { CellActionTypes } from '../cell-actions.type';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { TableTooltipConfig } from '../../config/table-tooltip.config';

@Component({
  selector: 'app-cell-remove',
  templateUrl: './cell-remove.component.html',
  styleUrls: ['./cell-remove.component.scss'],
  providers: [{ provide: NgbTooltipConfig, useClass: TableTooltipConfig }],
})
export class CellRemoveComponent extends TableCellState {
  public remove(): void {
    this.onAction(CellActionTypes.REMOVE);
  }

  public idNameAttr(names: string[]): string {
    return names.join('-');
  }
}
